var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TextDeformer } from "./TextDeformer";
import { DEFORMER_MANIP_ENUM } from "../enums";
var VERBOSE = false;
var TextOpacityDeformer = /** @class */ (function (_super) {
    __extends(TextOpacityDeformer, _super);
    function TextOpacityDeformer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._deformerType = [DEFORMER_MANIP_ENUM.COLOR];
        _this._opacities = [];
        return _this;
    }
    Object.defineProperty(TextOpacityDeformer.prototype, "animatableProperties", {
        get: function () {
            return ['opacities'];
        },
        enumerable: false,
        configurable: true
    });
    TextOpacityDeformer.prototype._uniforms = function () {
        return {
            uOpacities: this.opacities,
        };
    };
    TextOpacityDeformer.prototype._resetStateOnProperties = function (expectedLength) {
        VERBOSE && console.log('resetting state on properties', expectedLength);
        this._opacities = new Array(expectedLength).fill(1.0);
    };
    TextOpacityDeformer.prototype._updateProperties = function () {
        // Ensure we have populated the opacities array in case we haven't set it yet, otherwise we will get a shader
        // error.
        if (this._opacities.length === 0) {
            this._resetState();
        }
        _super.prototype._updateProperties.call(this);
    };
    Object.defineProperty(TextOpacityDeformer.prototype, "opacities", {
        get: function () {
            return this._opacities;
        },
        set: function (value) {
            this._validateData(value, 1);
            this._opacities = value;
            this.parent.shader.uniforms.uOpacities = value;
        },
        enumerable: false,
        configurable: true
    });
    TextOpacityDeformer.prototype._vertexHeader = function () {
        var transformCount = this.opacities.length;
        return "\n        varying float vOpacity;\n        attribute float aWeight;\n        uniform float uOpacities[".concat(transformCount, "];\n        ");
    };
    TextOpacityDeformer.prototype._vertexMain = function () {
        return "\n        int opacityTransformIndex = int(aWeight);\n        vOpacity = uOpacities[opacityTransformIndex];\n        ";
    };
    TextOpacityDeformer.prototype._fragmentHeader = function () {
        return "\n        varying float vOpacity;\n        ";
    };
    TextOpacityDeformer.prototype._fragBody = function () {
        return "\n        vec4 getColor".concat(this.index, "(vec4 inputColor) {\n            return vec4(inputColor.rgb, vOpacity);\n        }\n        ");
    };
    return TextOpacityDeformer;
}(TextDeformer));
export { TextOpacityDeformer };
